// webhooks.js
// Fires registered webhook endpoints via the Vercel edge function.
// Falls back to direct fetch in dev if no Vercel function is available.

const STORAGE_KEY = 'wm-webhooks-v1';

export function loadWebhooks() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch { return []; }
}

export function saveWebhooks(hooks) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(hooks)); } catch { /* no-op */ }
}

/**
 * Fire all webhooks registered for a given event type.
 * In dev mode, just logs to console.
 * In production, calls /api/webhook-dispatch which handles retry.
 */
export async function fireWebhook(event, payload) {
  const hooks = loadWebhooks().filter(h => h.active && h.events?.includes(event));
  if (hooks.length === 0) return;

  const isDev = import.meta.env.VITE_DEV_AUTH === '1';
  if (isDev) {
    console.info(`[webhooks] ${event}`, payload, '→', hooks.length, 'endpoint(s)');
    return;
  }

  try {
    await fetch('/api/webhook-dispatch', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event, payload, endpoints: hooks.map(h => ({ url: h.url, secret: h.secret })) }),
    });
  } catch (err) {
    console.error('[webhooks] dispatch failed:', err);
  }
}

// ─── Typed event helpers ──────────────────────────────────────────────────────
export const WEBHOOK_EVENTS = [
  'estimate.created',
  'estimate.approved',
  'estimate.declined',
  'invoice.paid',
  'work_order.completed',
  'customer.created',
];
